import { render } from "./Automezzi.vue?vue&type=template&id=6557fa0f&scoped=true&ts=true"
import script from "./Automezzi.vue?vue&type=script&lang=ts"
export * from "./Automezzi.vue?vue&type=script&lang=ts"

import "./Automezzi.vue?vue&type=style&index=0&id=6557fa0f&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6557fa0f"]])

export default __exports__